import { render } from "./SessionInitializer.vue?vue&type=template&id=315ad58a"
import script from "./SessionInitializer.vue?vue&type=script&lang=js"
export * from "./SessionInitializer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__